var module = angular.module('octopusApp.library');

module.controller('PackagesInfoDialogController', function ($scope, builtIn, $uibModalInstance) {

    $scope.builtIn = builtIn;

    $scope.close = function () {
        $uibModalInstance.close();
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/library/packages/controllers/packages_info_dialog_controller.js
// module id = 7478128514712278
// module chunks = 1